import {Routes, Route } from "react-router-dom";
import RootLayout from "../components/layout/layout";
import Home from "../pages/Home";
import Gallery from "../pages/Gallery";
import Reviews from "../pages/Reviews";
import Booking from "../pages/Booking";
import Shop from "../pages/Shop";
import Product from "../pages/Product";
import "../index.css";
import "react-day-picker/style.css";
import OurStory from "../pages/OurStory";
import Cart from "../pages/cart";
import Checkout from "../pages/checkout";
import PrivacyPolicyPage from "../pages/PrivacyPolicy";
import NotFound from "../pages/not-found";
import QuotePage from "../pages/Quote";
import ThankYouPage from "../pages/ThankYou";

const WebsiteRoutes = () => (
  <RootLayout>
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/gallery" element={<Gallery />} />
      <Route path="/reviews" element={<Reviews />} />
      <Route path="/booking" element={<Booking />} />
      <Route path="/quote-form/:id" element={<QuotePage />} />
      {/* <Route path="/shop" element={<Shop />} /> */}
      <Route path="/our-story" element={<OurStory />} />
      <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
      <Route path="/quote/thank-you" element={<ThankYouPage />} />
      {/* <Route path="/cart" element={<Cart />} /> */}
      {/* <Route path="/checkout" element={<Checkout />} /> */}
      {/* <Route path="/products/:id" element={<Product />} /> */}
      {/* 404 route - catches all unmatched paths */}
      <Route path="*" element={<NotFound />} />
    </Routes>
  </RootLayout>
);

export default WebsiteRoutes;